import React from 'react';
import { ArrowUpDown, Download, Filter, Plus } from 'lucide-react';
import Button from '../atoms/Button';

const fallbackStatusNames = ['Open', 'Closed'];

export default function ComplaintTableToolbar({
  selectedStatus,
  statusNames = [],
  updatedAtSortOldest,
  onStatusChange,
  onSortChange,
  onNewComplaint,
  onDownloadReport,
  isDownloadingReport = false,
  complaintTypeId,
}) {
  return (
    <div className="ca-complaint-table__toolbar">
      <div className="ca-complaint-table__filters">
        <label className="ca-complaint-table__filter">
          <Filter size={14} aria-hidden="true" />
          <span className="ca-complaint-table__sr-only">Filter by status</span>
          <select
            value={selectedStatus}
            aria-label="Filter by status"
            onChange={(event) => onStatusChange?.(event.target.value)}
          >
            <option value="all">Select Status</option>
            {(statusNames.length ? statusNames : fallbackStatusNames).map((name) => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
        </label>
        <button
          type="button"
          className={`ca-complaint-table__sort${updatedAtSortOldest ? ' ca-complaint-table__sort--reversed' : ''}`}
          aria-label={updatedAtSortOldest ? 'Sort by newest updated at date' : 'Sort by oldest updated at date'}
          title="Sort by Updated At"
          onClick={onSortChange}
        >
          <ArrowUpDown className="ca-complaint-table__sort-icon" size={14} aria-hidden="true" />
        </button>
      </div>
      <div className="ca-complaint-table__actions">
        <Button variant="outline" onClick={onNewComplaint} size="sm" startIcon={<Plus size={14} />}>
          New Complaint
        </Button>
        <Button
          variant="outline"
          size="sm"
          startIcon={<Download size={14} />}
          onClick={onDownloadReport}
          disabled={isDownloadingReport || !complaintTypeId}
        >
          Download Report
        </Button>
      </div>
    </div>
  );
}
